<template>
    <v-container>
        <div class="container-bg" style="margin-top: 1%; margin: auto">
            <div class="container-fg">
                <div style="display: flex; flex-direction: row">
                    <img style="width: 130px; margin-bottom: 1%" src="../../../assets/logos/getac-logo.svg" />
                    <div class="text-h7 nav-font pl-3" style="margin-top: 1.3%">INVENTORY</div>
                </div>
                <v-divider style="margin-bottom: 1%; border-color: gray" />
                <div>
                    <v-col cols="12" md="4" class="mb-2">
                        <v-text-field
                            v-model="search"
                            outlined
                            dense
                            placeholder="Search"
                            dark
                            hide-details
                        ></v-text-field>
                    </v-col>
                    <v-divider style="margin-bottom: 1%; border-color: gray" />
                </div>

                <v-data-table
                    id="demo-data-table"
                    dense
                    :headers="headers"
                    :items="querySMCustomerPartsUsage"
                    :search="search"
                    :loading="$apollo.loading"
                    :items-per-page="15"
                    dark
                >
                    <template v-slot:item.action="{ item }">
                        <v-btn class="elevation-0" x-small color="primary" @click="openUseItem(item)">Use</v-btn>
                    </template>
                </v-data-table>
            </div>
        </div>
        <v-dialog v-model="confirmUse" width="450px">
            <use-item
                :item="selectedInventory"
                @cancel="confirmUse = false"
                @submitted="submitInvUsage($event)"
                @errorSubmit="snackbarAlert($event)"
            ></use-item>
        </v-dialog>
        <v-snackbar v-model="snackbar">
            {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" color="white" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import gql from 'graphql-tag'
import UseItem from './use_item.vue'

export default {
    name: 'SMInventory',
    components: { UseItem },
    apollo: {
        querySMCustomerPartsUsage: {
            query: gql`
                query QuerySMCustomerPartsUsage($customerId: String, $queryAll: Boolean) {
                    querySMCustomerPartsUsage(customerId: $customerId, queryAll: $queryAll) {
                        customer
                        modelFamily
                        pn
                        category
                        partSpec
                        receivedQty
                        usedQty
                        stockQty
                        lastReplenishedDate
                        smId
                    }
                }
            `,
            variables() {
                return {
                    customerId: this.$auth.user.org.branchId,
                    queryAll: false
                }
            }
        }
    },
    data() {
        return {
            snackbar: false,
            snackbarMessage: ``,
            search: ``,
            confirmUse: false,
            selectedInventory: null,
            headers: [
                {
                    text: 'Category',
                    align: 'start',
                    sortable: false,
                    value: 'category'
                },
                {
                    text: 'Model Family',
                    value: 'modelFamily',
                    sortable: false,
                    align: 'start'
                },
                {
                    text: 'Part Spec',
                    value: 'partSpec',
                    sortable: false,
                    align: 'start'
                },
                {
                    text: 'Part Number',
                    value: 'pn',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Received Qty',
                    value: 'receivedQty',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Stock Qty',
                    value: 'stockQty',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Used Qty',
                    value: 'usedQty',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: '',
                    value: 'action',
                    sortable: false,
                    align: 'center'
                }
            ]
        }
    },
    methods: {
        snackbarAlert(e) {
            this.snackbar = true
            this.snackbarMessage = e
        },
        submitInvUsage(e) {
            const successful = e.data.useItem === 'success'
            if (successful) {
                this.confirmUse = false
                this.$apollo.queries.querySMCustomerPartsUsage.refetch()
            }
            this.snackbarAlert(successful ? 'Successfully submitted' : e.data.useItem)
        },
        openUseItem(item) {
            this.selectedInventory = item
            this.confirmUse = true
        }
    }
}
</script>

<style scoped>
#parts-select {
    margin-right: 100px;
}
.product-card {
    margin: auto;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    background-image: linear-gradient(155deg, rgba(90, 90, 90, 0.6), rgba(255, 255, 255, 0));
    border-radius: 10px;
    margin-bottom: 10px;
    border: 1px solid rgba(255, 255, 255, 0.3);
}
.product-card-bg {
    background: rgba(0, 0, 0, 0.349);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}
#model-select-heading {
    font-size: 36px;
    line-height: 0.9;
    letter-spacing: -0.1rem;
    margin-left: 10px;
    position: fixed;
    left: 0;
    /* bottom: 0; */
    margin-bottom: 100px;
    color: white;
}
.heading-line-two {
    color: #db5120 !important;
}
</style>
